export default __webpack_public_path__ + "static/media/BugType.0a9b8269.svg";